import { Link } from '@tanstack/react-router';
import { ArrowRight, KeyRound, LogIn } from 'lucide-react';
import { Logo } from '../../components/Logo';
import { useActiveBrand } from '../../api/brand';

/**
 * 401 Unauthorized / session expired — §10
 */
export function Unauthorized() {
  const brand = useActiveBrand();
  return (
    <div className="min-h-screen bg-marketing dark:bg-marketing-dark flex items-center justify-center px-4 py-10">
      <div className="w-full max-w-md text-center">
        <div className="flex flex-col items-center mb-7">
          <span
            aria-hidden="true"
            className="mono text-[88px] sm:text-[120px] leading-none font-semibold tracking-tighter text-zinc-200 dark:text-zinc-800 select-none"
          >
            401
          </span>
        </div>

        <div className="w-12 h-12 mx-auto -mt-12 mb-5 grid place-items-center rounded-full bg-white dark:bg-zinc-950 border border-zinc-200 dark:border-zinc-700 shadow-sm text-zinc-500 dark:text-zinc-400 relative">
          <KeyRound className="w-5 h-5" />
        </div>

        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight text-zinc-950 dark:text-zinc-50">
          Your session expired.
        </h1>
        <p className="mt-3 text-sm text-zinc-600 dark:text-zinc-300 max-w-sm mx-auto">
          For your security, we end inactive sessions automatically. Sign in again to pick up
          where you left off.
        </p>

        <div className="mt-8 flex justify-center">
          <Link
            to="/login"
            className="inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md text-sm font-medium bg-brand text-white shadow-xs hover:bg-brand-hover dark:bg-brand-dm dark:text-zinc-950 dark:hover:bg-brand-dm-hover transition"
          >
            <LogIn className="w-4 h-4" />
            Sign in
            <ArrowRight className="w-4 h-4" />
          </Link>
        </div>

        <p className="mt-8 text-xs text-zinc-500 dark:text-zinc-400">
          Forgot your password?{' '}
          <Link
            to="/forgot-password"
            className="text-brand dark:text-brand-dm hover:underline"
          >
            Reset it
          </Link>
        </p>

        <div className="mt-8 flex items-center justify-center gap-2 text-xs text-zinc-500 dark:text-zinc-400">
          <Logo className="w-5 h-5 rounded-md" />
          <span>{brand.name}</span>
        </div>
      </div>
    </div>
  );
}
